// The Vue build version to load with the `import` command
// 引入 polyfill 解决 util._extend 弃用警告
import './utils/polyfill.js'

// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// 引入分页器
import Pagination from "./components/Pagination.vue";
Vue.component(Pagination.name, Pagination);

// 引入element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/ef/index.css";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import KtButton from "@/permission/ktButton.vue";
import App from "./App";
// 引入路由
import router from "./router";
import RouterTab from "vue-router-tab";
import "vue-router-tab/dist/lib/vue-router-tab.css";
Vue.use(RouterTab);
// 引入状态管理
import storeBtn from "./store/index.js";
// 引入icon
import './assets/icon/iconfont.css'
//
import VueContextMenu from "vue-contextmenu";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import vuescroll from "vuescroll"; //引入vuescroll
import "vuescroll/dist/vuescroll.css"; //引入vuescroll样式
Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.component("KtButton", KtButton);

// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$FileSaver = FileSaver; //设置全局
Vue.prototype.$XLSX = XLSX; //设置全局
import axios from "axios";
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
// 使用element UI
Vue.use(ElementUI);
Vue.use(VueContextMenu);
Vue.use(vuescroll); //使用
import elTableInfiniteScroll from "el-table-infinite-scroll";

Vue.use(elTableInfiniteScroll);

import vueSeamlessScroll from "vue-seamless-scroll"; // 循环滚动
Vue.use(vueSeamlessScroll);

// 注册全局的组件
import libJs from "@/components/libs/index.js";
Vue.use(libJs);

import permissionStore from "./vuex/store.js";
import "./utils/directive/dialogDrag";

Vue.prototype.$eventBus = new Vue(); // 全局事件
Vue.prototype.$permissionStore = permissionStore;

Vue.config.productionTip = false;
// html导出pdf
import htmlToPdf from './utils/pdf.js'
Vue.use(htmlToPdf)

import * as stateHandle from "./utils/stateHandle.js";
Vue.prototype.$stateHandle = stateHandle;

import loadmore from './utils/loadmore.js'
Vue.directive(loadmore.name, loadmore.componentUpdated);

Vue.directive('permission', {
	inserted(el, binding) {
		// 假设用户权限存储在Vuex中
		const permissions = permissionStore.state.permission;
		// 判断用户是否拥有指定的权限
		if (!permissions[binding.value]) {
			el.parentNode && el.parentNode.removeChild(el); // 如果没有权限，则移除该元素
		}
	}
});


let historyList = []; //用于存储历史路由信息
// 路由拦截器
router.beforeEach((to, from, next) => {
	// 允许直接访问登录页、根路径、401和404页面
	if (to.path === '/login' || to.path === '/') {
		next();
	}
	else if (to.path === '/401' || to.path === '/404') {
		if (localStorage.getItem("userdata")) {
			next();
		}
		else {
			next({ path: '/login' });
		}
	}
	else if (localStorage.getItem("userdata")) {
		if (to.path === '/exeIndex/mainIndex/workbench') {
			next();
		} else {
			let hasPermission = false;
			const userdata = JSON.parse(localStorage.getItem("userdata"));
			userdata.permissionInfo.forEach((item) => {
				if (to.path === item.menuPath) {
					permissionStore.dispatch("SET_PERMISSION", item.btnOps);
					to.meta.title = item.menuName;
					to.meta.menuIcon = item.menuIcon;
					to.meta.menuColor = item.menuColor;
					to.meta.icon = item.menuIcon;
					hasPermission = true;
				}
			});

			if (hasPermission) {
				next();
			} else {
				// 检查路由是否存在
				const routeExists = router.options.routes.some(route => {
					// 检查顶层路由
					if (route.path === to.path) return true;
					// 检查子路由
					if (route.children && route.children.some(child => child.path === to.path)) return true;
					// 检查嵌套子路由
					if (route.children) {
						return route.children.some(child =>
							child.children && child.children.some(grandChild => grandChild.path === to.path)
						);
					}
					return false;
				});
				if (routeExists) {
					next({ path: '/401' });
				} else {
					next({ path: '/404' });
				}
			}
		}
	} else {
		// 如果没有登录信息，重定向到登录页
		next({ path: '/login' });
	}
});

Vue.prototype.$checkBtnPermission = function (menuPath, btnCode) {
	let userdata = localStorage.getItem('userdata');
	if (userdata) {
		let btnPermission = JSON.parse(userdata).permissionInfo;
		let menu = btnPermission.filter(item => item.menuPath == menuPath)[0];
		if (menu) {
			let btn = menu.btnOps.filter(item => item.menuCode == btnCode)[0];
			if (btn) {
				return true;
			}
		}
	}
	return false;
}

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	storeBtn, //使用storeBtn vuex状态管理
	components: {
		App,
	},
	template: "<App/>",
	data: {
		// 空的实例放到根组件下，所有的子组件都能调用
		Bus: new Vue(),
	},
});
